import has from 'lodash/has';

export interface Path {
  d: string;
  'stroke-width'?: string;
  'stroke-linecap'?: string;
  'stroke-linejoin'?: string;
  'fill-opacity'?: string;
  'fill-rule'?: string;
  'clip-rule'?: string;
  stroke?: string;
  style?: string;
  opacity?: string;
  fill?: string;
}

interface Circle {
  cx: number;
  cy: number;
  r: number;
}

export interface IconData {
  width: number;
  height: number;
  paths?: Path[];
  circles?: Circle[];

  rects?: Array<Dictionary<unknown>>;
  polygons?: Array<Dictionary<unknown>>;
}

const icons: Dictionary<IconData> = {};

export function validator(type: string) {
  return has(icons, type);
}

export function getIcon(type: string): IconData | null {
  return icons[type] || null;
}

export function getIcons(): string[] {
  return Object.keys(icons);
}

register('ai-generate', {
  width: 32,
  height: 34,
  paths: [
    {
      d: 'M10.8605 5.43116L11.0779 5.53986C11.9565 5.99276 12.6721 6.70833 13.125 7.58696L13.2337 7.80435C13.6685 8.66486 14.9003 8.66486 15.3442 7.80435L15.4529 7.58696C15.9058 6.70833 16.6214 5.99276 17.5 5.53986L17.7174 5.43116C18.5779 4.99638 18.5779 3.76449 17.7174 3.32065L17.5 3.21196C16.6214 2.75906 15.9058 2.04348 15.4529 1.16486L15.3442 0.947466C14.9094 0.0869591 13.6775 0.0869591 13.2337 0.947466L13.125 1.16486C12.6721 2.04348 11.9565 2.75906 11.0779 3.21196L10.8605 3.32065C9.99997 3.75544 9.99997 4.98732 10.8605 5.43116Z',
    },
    {
      d: 'M12.5724 13.9185C13.4601 13.4656 13.4601 12.2065 12.5724 11.7536L11.25 11.0743C10.0724 10.4674 9.11229 9.50725 8.50541 8.32971L7.82606 7.00725C7.37316 6.11957 6.11411 6.11957 5.66121 7.00725L4.98186 8.32971C4.37498 9.50725 3.41483 10.4674 2.23729 11.0743L0.91483 11.7536C0.0271489 12.2065 0.0271489 13.4656 0.91483 13.9185L2.23729 14.5978C3.41483 15.2047 4.37498 16.1649 4.98186 17.3424L5.66121 18.6649C6.11411 19.5525 7.37316 19.5525 7.82606 18.6649L8.50541 17.3424C9.11229 16.1649 10.0724 15.2047 11.25 14.5978L12.5724 13.9185Z',
    },
    {
      d: 'M29.5652 19.3351L28.2246 18.6467C26.6032 17.8225 25.3079 16.5272 24.4837 14.9058L23.7953 13.5652C23.1884 12.3696 21.9746 11.6268 20.634 11.6268C19.2935 11.6268 18.0797 12.3696 17.4728 13.5652L16.7844 14.9058C15.9601 16.5272 14.6648 17.8225 13.0435 18.6467L11.7029 19.3351C10.5072 19.942 9.76447 21.1558 9.76447 22.4964C9.76447 23.837 10.5072 25.0507 11.7029 25.6576L13.0435 26.346C14.6648 27.1703 15.9601 28.4656 16.7844 30.087L17.4728 31.4275C18.0797 32.6232 19.2935 33.3659 20.634 33.3659C21.9746 33.3659 23.1884 32.6232 23.7953 31.4275L24.4837 30.087C25.3079 28.4656 26.6032 27.1703 28.2246 26.346L29.5652 25.6576C30.7608 25.0507 31.5036 23.837 31.5036 22.4964C31.5036 21.1558 30.7608 19.942 29.5652 19.3351ZM28.3333 23.2391L26.9927 23.9275C24.855 25.0145 23.1521 26.7174 22.0652 28.8551L21.3768 30.1957C21.1685 30.6033 20.788 30.6486 20.634 30.6486C20.48 30.6486 20.0996 30.6033 19.8913 30.1957L19.2029 28.8551C18.1159 26.7174 16.413 25.0145 14.2753 23.9275L12.9348 23.2391C12.5271 23.0308 12.4819 22.6504 12.4819 22.4964C12.4819 22.3424 12.5271 21.962 12.9348 21.7536L14.2753 21.0652C16.413 19.9783 18.1159 18.2754 19.2029 16.1377L19.8913 14.7971C20.0996 14.3895 20.48 14.3442 20.634 14.3442C20.788 14.3442 21.1685 14.3895 21.3768 14.7971L22.0652 16.1377C23.1521 18.2754 24.855 19.9783 26.9927 21.0652L28.3333 21.7536C28.7409 21.962 28.7862 22.3424 28.7862 22.4964C28.7862 22.6504 28.7409 23.0308 28.3333 23.2391Z',
    },
  ],
});

register('file-icon', {
  width: 53,
  height: 60,
  paths: [
    {
      'fill-rule': 'evenodd',
      'clip-rule': 'evenodd',
      d: 'M27.5 50H37.5C38.052 50 38.5 49.552 38.5 49C38.5 48.448 38.052 48 37.5 48H27.5C26.948 48 26.5 48.448 26.5 49C26.5 49.552 26.948 50 27.5 50ZM11.5 50H23.5C24.052 50 24.5 49.552 24.5 49C24.5 48.448 24.052 48 23.5 48H11.5C10.948 48 10.5 48.448 10.5 49C10.5 49.552 10.948 50 11.5 50ZM23.5 38H39.5C40.052 38 40.5 37.552 40.5 37C40.5 36.448 40.052 36 39.5 36H23.5C22.948 36 22.5 36.448 22.5 37C22.5 37.552 22.948 38 23.5 38ZM32.5 43C32.5 42.448 32.052 42 31.5 42H21.5C20.948 42 20.5 42.448 20.5 43C20.5 43.552 20.948 44 21.5 44H31.5C32.052 44 32.5 43.552 32.5 43ZM42.5 43C42.5 42.448 42.052 42 41.5 42H35.5C34.948 42 34.5 42.448 34.5 43C34.5 43.552 34.948 44 35.5 44H41.5C42.052 44 42.5 43.552 42.5 43ZM11.5 44H17.5C18.052 44 18.5 43.552 18.5 43C18.5 42.448 18.052 42 17.5 42H11.5C10.948 42 10.5 42.448 10.5 43C10.5 43.552 10.948 44 11.5 44ZM37.5 30H31.5C30.948 30 30.5 30.448 30.5 31C30.5 31.552 30.948 32 31.5 32H37.5C38.052 32 38.5 31.552 38.5 31C38.5 30.448 38.052 30 37.5 30ZM23.5 32H27.5C28.052 32 28.5 31.552 28.5 31C28.5 30.448 28.052 30 27.5 30H23.5C22.948 30 22.5 30.448 22.5 31C22.5 31.552 22.948 32 23.5 32ZM11.5 32H19.5C20.052 32 20.5 31.552 20.5 31C20.5 30.448 20.052 30 19.5 30H11.5C10.948 30 10.5 30.448 10.5 31C10.5 31.552 10.948 32 11.5 32ZM11.5 38H19.5C20.052 38 20.5 37.552 20.5 37C20.5 36.448 20.052 36 19.5 36H11.5C10.948 36 10.5 36.448 10.5 37C10.5 37.552 10.948 38 11.5 38ZM41.5 24H33.5C32.948 24 32.5 24.448 32.5 25C32.5 25.552 32.948 26 33.5 26H41.5C42.052 26 42.5 25.552 42.5 25C42.5 24.448 42.052 24 41.5 24ZM11.5 26H29.5C30.052 26 30.5 25.552 30.5 25C30.5 24.448 30.052 24 29.5 24H11.5C10.948 24 10.5 24.448 10.5 25C10.5 25.552 10.948 26 11.5 26ZM11.5 18H21.5C22.052 18 22.5 17.552 22.5 17C22.5 16.448 22.052 16 21.5 16H11.5C10.948 16 10.5 16.448 10.5 17C10.5 17.552 10.948 18 11.5 18ZM52.5 15V55C52.5 57.757 50.257 60 47.5 60H5.5C2.743 60 0.5 57.757 0.5 55V5C0.5 2.243 2.743 0 5.5 0H37.5C37.765 0 38.02 0.105 38.207 0.293L48.207 10.293C48.598 10.684 48.598 11.316 48.207 11.707C47.816 12.098 47.184 12.098 46.793 11.707L37.086 2H5.5C3.846 2 2.5 3.346 2.5 5V55C2.5 56.654 3.846 58 5.5 58H47.5C49.154 58 50.5 56.654 50.5 55V16H41.5C38.743 16 36.5 13.757 36.5 11V6C36.5 5.448 36.948 5 37.5 5C38.052 5 38.5 5.448 38.5 6V11C38.5 12.654 39.846 14 41.5 14H51.5C52.052 14 52.5 14.448 52.5 15Z',
    },
  ],
});

register('trash', {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M12.9109 3.27272H17.1818C17.6326 3.27272 18 3.63926 18 4.0909C18 4.54253 17.6326 4.90908 17.1818 4.90908H15.9464L14.8083 16.5681C14.7044 17.3912 14.0024 18.0065 13.1719 17.9999H4.82727C3.99273 18.0008 3.29073 17.3732 3.19909 16.5436L2.05282 4.90908H0.818182C0.366545 4.90908 0 4.54253 0 4.0909C0 3.63926 0.366545 3.27272 0.818182 3.27272H5.08827L5.44091 1.85727C5.715 0.765816 6.69518 0 7.821 0H10.1782C11.304 0 12.2842 0.765816 12.5583 1.85727L12.9109 3.27272ZM4.81827 16.3636H13.1645L14.2928 4.90908H3.70636L4.81827 16.3636ZM7.02818 2.25818L6.77455 3.27272H11.2246L11.0201 2.25818C10.9285 1.88427 10.5881 1.6249 10.2019 1.63636H7.84636C7.461 1.6249 7.12064 1.88427 7.02818 2.25818ZM6.54545 8.1818V13.0909C6.54545 13.5425 6.912 13.9091 7.36364 13.9091C7.81445 13.9091 8.18182 13.5425 8.18182 13.0909V8.1818C8.18182 7.73016 7.81445 7.36362 7.36364 7.36362C6.912 7.36362 6.54545 7.73016 6.54545 8.1818ZM9.81818 13.0909V8.1818C9.81818 7.73016 10.1847 7.36362 10.6364 7.36362C11.0872 7.36362 11.4545 7.73016 11.4545 8.1818V13.0909C11.4545 13.5425 11.0872 13.9091 10.6364 13.9091C10.1847 13.9091 9.81818 13.5425 9.81818 13.0909Z',
    },
  ],
});

register('calendar', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M7,10H12V15H7M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z',
    },
  ],
});

register('image', {
  width: 64,
  height: 64,
  paths: [
    {
      d: 'M36.6193 22.9375V3C36.6193 1.89543 35.7239 1 34.6193 1H3C1.89543 1 1 1.89543 1 3V26.75C1 27.8546 1.89543 28.75 3 28.75H34.6193C35.7239 28.75 36.6193 27.8546 36.6193 26.75V22.9375ZM36.6193 22.9375L26.1585 12.6403C25.3282 11.8229 23.9778 11.8855 23.2267 12.7762L16.2382 21.0625L12.9009 17.9143C12.189 17.2427 11.0955 17.185 10.3169 17.7779L1.57143 24.4375',
    },
  ],
});

register('check-circle', {
  width: 64,
  height: 64,
  paths: [
    {
      d: 'M32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0ZM4 32C4 16.536 16.536 4 32 4C47.464 4 60 16.536 60 32C60 47.464 47.464 60 32 60C16.536 60 4 47.464 4 32ZM13.437 28.6937C14.2921 27.8304 15.685 27.8239 16.5483 28.679L28.2239 40.2438L48.294 21.3964C49.1797 20.5646 50.572 20.6083 51.4037 21.494C52.2355 22.3798 52.1918 23.772 51.3061 24.6038L29.6891 44.9038C28.826 45.7144 27.4761 45.6963 26.6349 44.863L13.4518 31.8049C12.5886 30.95 12.582 29.557 13.437 28.6937Z',
    },
  ],
});

register('my-groups', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M5.10938 3.972C5.10938 2.60675 6.21613 1.5 7.58137 1.5C8.94662 1.5 10.0534 2.60675 10.0534 3.972C10.0534 5.33725 8.94662 6.444 7.58137 6.444C6.21613 6.444 5.10938 5.33725 5.10938 3.972ZM7.58137 0C5.3877 0 3.60938 1.77832 3.60938 3.972C3.60938 6.16567 5.3877 7.944 7.58137 7.944C9.77505 7.944 11.5534 6.16567 11.5534 3.972C11.5534 1.77832 9.77505 0 7.58137 0ZM4.35872 9.66406C3.30528 9.66406 2.29498 10.0825 1.55009 10.8274C0.805196 11.5723 0.386719 12.5826 0.386719 13.6361V15.2471C0.386719 15.6613 0.722505 15.9971 1.13672 15.9971C1.55093 15.9971 1.88672 15.6613 1.88672 15.2471V13.6361C1.88672 12.9804 2.14716 12.3517 2.61075 11.8881C3.07434 11.4245 3.7031 11.1641 4.35872 11.1641H10.8027C11.4583 11.1641 12.0871 11.4245 12.5507 11.8881C13.0143 12.3517 13.2747 12.9804 13.2747 13.6361V15.2471C13.2747 15.6613 13.6105 15.9971 14.0247 15.9971C14.4389 15.9971 14.7747 15.6613 14.7747 15.2471V13.6361C14.7747 12.5826 14.3562 11.5723 13.6113 10.8274C12.8664 10.0825 11.8562 9.66406 10.8027 9.66406H4.35872ZM15.7193 10.3361C15.8229 9.93506 16.2319 9.69388 16.633 9.79743C17.4851 10.0175 18.24 10.5142 18.7792 11.2098C19.3184 11.9053 19.6113 12.7603 19.612 13.6403L19.612 15.2519C19.612 15.6661 19.2762 16.0019 18.862 16.0019C18.4478 16.0019 18.112 15.6661 18.112 15.2519V13.6415C18.1116 13.0938 17.9293 12.5616 17.5937 12.1288C17.2582 11.6959 16.7883 11.3867 16.258 11.2498C15.8569 11.1463 15.6158 10.7372 15.7193 10.3361ZM13.405 0.132993C13.0037 0.0302518 12.5951 0.272257 12.4924 0.673526C12.3896 1.0748 12.6316 1.48338 13.0329 1.58612C13.5646 1.72226 14.0359 2.03151 14.3725 2.46511C14.7091 2.8987 14.8917 3.43198 14.8917 3.98087C14.8917 4.52976 14.7091 5.06303 14.3725 5.49663C14.0359 5.93022 13.5646 6.23947 13.0329 6.37562C12.6316 6.47836 12.3896 6.88694 12.4924 7.28821C12.5951 7.68948 13.0037 7.93148 13.405 7.82874C14.2594 7.60998 15.0166 7.11308 15.5574 6.41639C16.0982 5.71969 16.3917 4.86282 16.3917 3.98087C16.3917 3.09891 16.0982 2.24204 15.5574 1.54535C15.0166 0.848649 14.2594 0.351752 13.405 0.132993Z',
    },
  ],
});

register('cancel-outline', {
  width: 22,
  height: 22,
  paths: [
    {
      d: 'M10.9992 0.203125C5.03454 0.203125 0.199219 5.03845 0.199219 11.0031C0.199219 16.9678 5.03454 21.8031 10.9992 21.8031C16.9639 21.8031 21.7992 16.9678 21.7992 11.0031C21.7992 5.03845 16.9639 0.203125 10.9992 0.203125ZM10.9992 2.00313C15.9698 2.00313 19.9992 6.03256 19.9992 11.0031C19.9992 15.9737 15.9698 20.0031 10.9992 20.0031C6.02866 20.0031 1.99922 15.9737 1.99922 11.0031C1.99922 6.03256 6.02866 2.00313 10.9992 2.00313ZM13.4995 7.1847C13.851 6.83323 14.4208 6.83323 14.7723 7.1847C15.1238 7.53618 15.1238 8.10602 14.7723 8.4575L12.2267 11.0031L14.7722 13.5487C15.1237 13.9002 15.1237 14.47 14.7722 14.8215C14.4208 15.173 13.8509 15.173 13.4994 14.8215L10.9539 12.2759L8.40833 14.8215C8.05686 15.1729 7.48701 15.1729 7.13554 14.8215C6.78407 14.47 6.78407 13.9001 7.13554 13.5487L9.68108 11.0031L7.13548 8.45753C6.78401 8.10605 6.78401 7.5362 7.13548 7.18473C7.48695 6.83326 8.0568 6.83326 8.40827 7.18473L10.9539 9.73033L13.4995 7.1847Z',
    },
  ],
});

register('pause-outline', {
  width: 23,
  height: 23,
  paths: [
    {
      d: 'M9,16h2V8H9V16z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8 s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M13,16h2V8h-2V16z',
    },
  ],
});

register('play-circle-outline', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M10,16.5L16,12L10,7.5V16.5Z',
    },
  ],
});

register('loading', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z',
    },
  ],
});

register('disabled', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22 2 17.5 2 12 6.5 2 12 2M12 4C10.1 4 8.4 4.6 7.1 5.7L18.3 16.9C19.3 15.5 20 13.8 20 12C20 7.6 16.4 4 12 4M16.9 18.3L5.7 7.1C4.6 8.4 4 10.1 4 12C4 16.4 7.6 20 12 20C13.9 20 15.6 19.4 16.9 18.3Z',
    },
  ],
});

register('info-outline', {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M9 0C4.02965 0 0 4.02965 0 9C0 13.9703 4.02965 18 9 18C13.9703 18 18 13.9703 18 9C17.9953 4.03122 13.9688 0.00469565 9 0ZM9 16.5C4.85763 16.5 1.5 13.1424 1.5 9C1.5 4.85763 4.85763 1.5 9 1.5C13.1424 1.5 16.5 4.85763 16.5 9C16.4953 13.14 13.14 16.4953 9 16.5ZM8.25 8.25C8.25 7.83579 8.58579 7.5 9 7.5C9.41421 7.5 9.75 7.83579 9.75 8.25V12.75C9.75 13.1642 9.41421 13.5 9 13.5C8.58579 13.5 8.25 13.1642 8.25 12.75V8.25ZM9 6C9.414 6 9.75 5.664 9.75 5.25C9.75 4.836 9.414 4.5 9 4.5C8.586 4.5 8.25 4.836 8.25 5.25C8.25 5.664 8.586 6 9 6Z',
    },
  ],
});

register('cc', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19,4H5C3.89,4,3,4.9,3,6v12c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V6C21,4.9,20.1,4,19,4z M11,10.5 c0,0.28-0.22,0.5-0.5,0.5H10c-0.28,0-0.5-0.22-0.5-0.5h-2v3h2c0-0.28,0.22-0.5,0.5-0.5h0.5c0.28,0,0.5,0.22,0.5,0.5V14 c0,0.55-0.45,1-1,1H7c-0.55,0-1-0.45-1-1v-4c0-0.55,0.45-1,1-1h3c0.55,0,1,0.45,1,1V10.5z M18,10.5c0,0.28-0.22,0.5-0.5,0.5H17 c-0.28,0-0.5-0.22-0.5-0.5h-2v3h2c0-0.28,0.22-0.5,0.5-0.5h0.5c0.28,0,0.5,0.22,0.5,0.5V14c0,0.55-0.45,1-1,1h-3 c-0.55,0-1-0.45-1-1v-4c0-0.55,0.45-1,1-1h3c0.55,0,1,0.45,1,1V10.5z',
    },
  ],
});

register('portal-upload', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M10.1336 1.96825C10.4261 1.67725 10.8986 1.67725 11.1911 1.96825L16.4336 7.22575C16.6884 7.5235 16.6713 7.96675 16.3943 8.24425C16.1172 8.521 15.6737 8.53825 15.3761 8.28325L11.4086 4.30825V14.5007C11.4086 14.915 11.0728 15.2507 10.6586 15.2507C10.2444 15.2507 9.90859 14.915 9.90859 14.5007V4.30825L5.94109 8.27575C5.64349 8.53075 5.19994 8.5135 4.92289 8.23675C4.64592 7.95925 4.62874 7.516 4.88359 7.21825L10.1336 1.96825ZM2.95312 16.75C2.53892 16.75 2.20312 17.086 2.20312 17.5C2.20312 17.914 2.53892 18.25 2.95312 18.25H17.9531C18.3673 18.25 18.7031 17.914 18.7031 17.5C18.7031 17.086 18.3673 16.75 17.9531 16.75H2.95312Z',
    },
  ],
});

register('refresh', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z',
    },
  ],
});

register('unfold-more', {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M9 4.12l2.38 2.38 1.06-1.06L9 2 5.56 5.44 6.62 6.5 9 4.12zm0 9.76L6.62 11.5l-1.06 1.06L9 16l3.44-3.44-1.06-1.06L9 13.88z',
    },
  ],
});

register('checkbox', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z',
    },
  ],
});

register('checkbox-outline', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z',
    },
  ],
});

register('checkbox-invert', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z',
    },
    {
      d: 'm7.459209,12.171257l-0.464735,-0.542763l-0.945725,1.403848l3.91046,4.141408l7.992042,-8.881153l-1.189065,-1.466348l-6.677977,7.970008z',
    },
  ],
});

register('radiobutton-checked', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z',
    },
  ],
});

register('radiobutton-unchecked', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z',
    },
  ],
});

register('apps', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z',
    },
  ],
});

register('search', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z',
    },
  ],
});

register('tune', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z',
    },
  ],
});

register('menu', {
  width: 19,
  height: 20,
  paths: [
    {
      d: 'M1 2.5H19C19.552 2.5 20 2.052 20 1.5C20 0.948 19.552 0.5 19 0.5H1C0.448 0.5 0 0.948 0 1.5C0 2.052 0.448 2.5 1 2.5ZM19 8.5H1C0.448 8.5 0 8.948 0 9.5C0 10.052 0.448 10.5 1 10.5H19C19.552 10.5 20 10.052 20 9.5C20 8.948 19.552 8.5 19 8.5ZM1 16.5H19C19.552 16.5 20 16.948 20 17.5C20 18.052 19.552 18.5 19 18.5H1C0.448 18.5 0 18.052 0 17.5C0 16.948 0.448 16.5 1 16.5Z',
    },
  ],
});

register('upload', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z',
    },
  ],
});

register('help', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z',
    },
  ],
});

register('close', {
  width: 20,
  height: 20,
  paths: [
    {
      d: 'M11.4101 10.0004L18.7101 2.71042C19.1021 2.31842 19.1021 1.68242 18.7101 1.29042C18.3181 0.898424 17.6821 0.898424 17.2901 1.29042L10.0001 8.59042L2.71014 1.29042C2.45614 1.03642 2.08714 0.937424 1.74014 1.03042C1.39414 1.12342 1.12314 1.39442 1.03014 1.74042C0.937141 2.08742 1.03614 2.45642 1.29014 2.71042L8.59014 10.0004L1.29014 17.2904C1.10114 17.4784 0.994141 17.7334 0.994141 18.0004C0.994141 18.2674 1.10114 18.5224 1.29014 18.7104C1.47814 18.8994 1.73314 19.0064 2.00014 19.0064C2.26714 19.0064 2.52214 18.8994 2.71014 18.7104L10.0001 11.4104L17.2901 18.7104C17.4781 18.8994 17.7331 19.0064 18.0001 19.0064C18.2671 19.0064 18.5221 18.8994 18.7101 18.7104C18.8991 18.5224 19.0061 18.2674 19.0061 18.0004C19.0061 17.7334 18.8991 17.4784 18.7101 17.2904L11.4101 10.0004Z',
    },
  ],
});

register('arrow-left', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z',
    },
  ],
});

register('arrow-right', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M1.99609 7.62939e-06C2.26203 -0.000991821 2.51697 0.102985 2.70593 0.289942L10.7041 8.28808C10.893 8.47604 11 8.73098 11 8.99792C11 9.26485 10.893 9.5198 10.7041 9.70775L2.70593 17.706C2.31402 18.098 1.67817 18.098 1.28626 17.706C0.894349 17.3139 0.894349 16.6781 1.28626 16.2862L8.58456 8.99792L1.28626 1.70961C1.0973 1.52166 0.990326 1.26671 0.990326 0.999775C0.990326 0.732838 1.0973 0.477898 1.28626 0.289942C1.47521 0.102985 1.73015 -0.000991821 1.99609 7.62939e-06Z',
    },
  ],
});

register('chevron-right', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z',
    },
  ],
});

register('chevron-left', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z',
    },
  ],
});

register('chevron-down', {
  width: 12,
  height: 7,
  paths: [
    {
      d: 'M11.032 0.969515C10.7395 0.678824 10.2672 0.678824 9.97482 0.969515L6.00122 4.94312L2.03512 0.969515C1.74113 0.675526 1.26448 0.675526 0.970491 0.969515C0.676503 1.2635 0.676503 1.74015 0.970491 2.03414L5.46891 6.53256C5.76133 6.82325 6.23361 6.82325 6.52604 6.53256L11.0245 2.03414C11.1674 1.89437 11.2486 1.7033 11.25 1.50339C11.2514 1.30348 11.1729 1.11129 11.032 0.969515Z',
    },
  ],
});

register('dot', {
  width: 24,
  height: 24,
  circles: [
    {
      cx: 12,
      cy: 12,
      r: 10,
    },
  ],
});

register('eye', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z',
    },
  ],
});

register('thumb-up', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15.86 8.00031C15.8913 8.60631 15.7073 9.20364 15.3407 9.68698C15.3047 9.73631 15.2713 9.78698 15.24 9.83965C15.5953 10.7383 15.5867 11.7403 15.2153 12.633C15.074 13.9556 13.9893 14.9776 12.66 15.0403H9.494C8.54 15.0416 7.59667 14.8476 6.72067 14.471L4.75133 13.7176C4.50333 13.623 4.34 13.3856 4.34 13.1203V6.72031C4.34 6.55031 4.40733 6.38765 4.52733 6.26765C4.64733 6.14764 4.81 6.08031 4.98 6.08031C6.03467 6.08031 6.64733 5.79498 6.96733 5.15431C7.26133 4.60298 7.682 4.13031 8.19533 3.77498C8.65933 3.41231 8.82 3.26698 8.82 2.88031V0.960312C8.82 0.790312 8.88733 0.627646 9.00733 0.507646C9.12733 0.387646 9.29 0.320312 9.46 0.320312C10.8733 0.321646 12.0187 1.46698 12.02 2.88031V4.17698C12.02 4.65898 11.9427 5.13698 11.79 5.59431L11.628 6.08031H13.94C15 6.08165 15.8587 6.94031 15.86 8.00031ZM1.16667 4.80031C0.798667 4.80031 0.5 5.09898 0.5 5.46698V14.3736C0.5 14.7416 0.798667 15.0403 1.16667 15.0403H2.39333C2.76133 15.0403 3.06 14.7416 3.06 14.3736V5.46698C3.06 5.09898 2.76133 4.80031 2.39333 4.80031H1.16667Z',
    },
  ],
});

register('thumb-up-outline', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15.4967 8.29328C15.5281 8.89928 15.3441 9.49661 14.9774 9.97995C14.9414 10.0293 14.9081 10.0799 14.8767 10.1326C15.2321 11.0313 15.2234 12.0333 14.8521 12.9259C14.7107 14.2486 13.6254 15.2706 12.2967 15.3333H9.13072C8.17672 15.3346 7.23339 15.1406 6.35739 14.7639L4.03005 13.7666V14.6666C4.03005 15.0346 3.73139 15.3333 3.36339 15.3333H0.776719C0.606719 15.3333 0.444052 15.2659 0.324052 15.1459C0.204052 15.0259 0.136719 14.8633 0.136719 14.6933V5.73328C0.136719 5.56328 0.204052 5.40061 0.324052 5.28061C0.444052 5.16061 0.606719 5.09328 0.776719 5.09328H3.33672C3.50672 5.09328 3.66939 5.16061 3.78939 5.28061C3.90939 5.40061 3.97672 5.56328 3.97672 5.73328V6.32728C4.54872 6.28995 5.06005 5.95661 5.32405 5.44728C5.61805 4.89595 6.03872 4.42328 6.55205 4.06795C7.01605 3.70528 7.17672 3.55995 7.17672 3.17328V1.25328C7.17672 1.08328 7.24405 0.920615 7.36405 0.800615C7.48405 0.680615 7.64672 0.613281 7.81672 0.613281H8.45672C9.87005 0.614615 11.0154 1.75995 11.0167 3.17328V4.46995C11.0167 4.95195 10.9387 5.42995 10.7867 5.88728L10.6247 6.37328H13.5767C14.6367 6.37461 15.4954 7.23328 15.4967 8.29328ZM1.41672 14.0533H2.69672V6.37328H1.41672V14.0533ZM13.5767 10.2133C13.5821 9.85861 13.7074 9.51595 13.9327 9.24128C14.1441 8.97262 14.2461 8.63395 14.2167 8.29328C14.2161 7.93995 13.9301 7.65395 13.5767 7.65328H9.73672C9.53072 7.65328 9.33739 7.55461 9.21739 7.38728C9.09739 7.22061 9.06472 7.00595 9.12939 6.81061L9.57205 5.48195C9.68139 5.15595 9.73672 4.81395 9.73672 4.46995V3.17328C9.73605 2.46661 9.16339 1.89395 8.45672 1.89328V3.17328C8.43805 3.95795 8.01539 4.67728 7.33939 5.07661C6.97872 5.31728 6.68072 5.64061 6.46939 6.01928C5.98339 6.95861 5.03272 7.56728 3.97672 7.61461V12.3513L6.86139 13.5879C7.57805 13.8959 8.35005 14.0539 9.13072 14.0533H12.2967C12.9761 13.9913 13.5147 13.4533 13.5767 12.7733C13.5767 12.6739 13.5994 12.5759 13.6441 12.4873C13.9234 11.8539 13.9234 11.1326 13.6441 10.4993C13.5994 10.4106 13.5767 10.3126 13.5767 10.2133Z',
    },
  ],
});

register('chat', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z',
    },
  ],
});

register('star', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z',
    },
  ],
});

register('video', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M4 6.47L5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z',
    },
  ],
});

register('audio', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M3 9v6h4l5 5V4L7 9H3zm7-.17v6.34L7.83 13H5v-2h2.83L10 8.83zM16.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z',
    },
  ],
});

register('document', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z',
    },
  ],
});

register('audioplaylist', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z',
    },
  ],
});

register('videoplaylist', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 9H2v2h17V9zm0-4H2v2h17V5zM2 15h13v-2H2v2zm15-2v6l5-3-5-3z',
    },
  ],
});

register('broadcast', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M 5.78125 4.1875 C 3.48125 6.0215 2 8.837 2 12 C 2 15.163 3.48125 17.9785 5.78125 19.8125 L 7.03125 18.25 C 5.19125 16.783 4 14.53 4 12 C 4 9.47 5.19125 7.217 7.03125 5.75 L 5.78125 4.1875 z M 18.25 4.1875 L 17 5.75 C 18.83 7.218 20 9.477 20 12 C 20 14.523 18.83 16.782 17 18.25 L 18.25 19.8125 C 20.538 17.9775 22 15.154 22 12 C 22 8.846 20.538 6.0215 18.25 4.1875 z M 8.28125 7.3125 C 6.90125 8.4125 6 10.102 6 12 C 6 13.898 6.90125 15.5875 8.28125 16.6875 L 9.53125 15.125 C 8.61225 14.391 8 13.265 8 12 C 8 10.735 8.61225 9.609 9.53125 8.875 L 8.28125 7.3125 z M 15.75 7.3125 L 14.5 8.90625 C 15.416 9.64025 16 10.739 16 12 C 16 13.262 15.415 14.36075 14.5 15.09375 L 15.75 16.6875 C 17.122 15.5875 18 13.892 18 12 C 18 10.108 17.123 8.4135 15.75 7.3125 z M 12 10.5 C 11.171573 10.5 10.5 11.171573 10.5 12 C 10.5 12.828427 11.171573 13.5 12 13.5 C 12.828427 13.5 13.5 12.828427 13.5 12 C 13.5 11.171573 12.828427 10.5 12 10.5 z',
    },
  ],
});

register('playlist', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 9H2v2h17V9zm0-4H2v2h17V5zM2 15h13v-2H2v2zm15-2v6l5-3-5-3z',
    },
  ],
});

register('collections-bookmark', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z',
    },
  ],
});

register('arrow-down', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z',
    },
  ],
});

register('date-range', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z',
    },
  ],
});

register('filter', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z',
    },
  ],
});

register('grid-view', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z',
    },
  ],
});

register('list-view', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z',
    },
  ],
});

register('drop-down', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M7 10l5 5 5-5z',
    },
  ],
});

register('arrow-up', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z',
    },
  ],
});

register('lock', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z',
    },
  ],
});

register('arrow-forward', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z',
    },
  ],
});

register('arrow-back', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z',
    },
  ],
});

register('code', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z',
    },
  ],
});

register('subdirectory', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z',
    },
  ],
});

register('delete', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z',
    },
  ],
});

register('group', {
  width: 90,
  height: 45,
  paths: [
    {
      d: 'M45.5 25.8125C51.6125 25.8125 57.0125 27.275 61.4 29.1875C65.45 30.9875 68 35.0375 68 39.425V45.5H23V39.4625C23 35.0375 25.55 30.9875 29.6 29.225C33.9875 27.275 39.3875 25.8125 45.5 25.8125ZM15.5 26.75C19.625 26.75 23 23.375 23 19.25C23 15.125 19.625 11.75 15.5 11.75C11.375 11.75 8 15.125 8 19.25C8 23.375 11.375 26.75 15.5 26.75ZM19.7375 30.875C18.35 30.65 16.9625 30.5 15.5 30.5C11.7875 30.5 8.2625 31.2875 5.075 32.675C2.3 33.875 0.5 36.575 0.5 39.6125V45.5H17.375V39.4625C17.375 36.35 18.2375 33.425 19.7375 30.875ZM75.5 26.75C79.625 26.75 83 23.375 83 19.25C83 15.125 79.625 11.75 75.5 11.75C71.375 11.75 68 15.125 68 19.25C68 23.375 71.375 26.75 75.5 26.75ZM90.5 39.6125C90.5 36.575 88.7 33.875 85.925 32.675C82.7375 31.2875 79.2125 30.5 75.5 30.5C74.0375 30.5 72.65 30.65 71.2625 30.875C72.7625 33.425 73.625 36.35 73.625 39.4625V45.5H90.5V39.6125ZM45.5 0.5C51.725 0.5 56.75 5.525 56.75 11.75C56.75 17.975 51.725 23 45.5 23C39.275 23 34.25 17.975 34.25 11.75C34.25 5.525 39.275 0.5 45.5 0.5Z',
    },
  ],
});

register('public', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z',
    },
  ],
});

register('lock-open', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z',
    },
  ],
});

register('lock', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z',
    },
  ],
});

register('link', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M17.2719 15.0703C17.1007 15.0697 16.9336 15.0164 16.7916 14.917C16.6494 14.8177 16.5386 14.6766 16.4732 14.5117C16.4077 14.3467 16.3905 14.1653 16.4236 13.9902C16.4567 13.815 16.5387 13.6539 16.6594 13.5274L20.503 9.51701C22.191 7.75552 22.191 4.88916 20.503 3.12706C18.8143 1.36556 16.0665 1.36556 14.379 3.12706L10.536 7.13742C10.4564 7.22516 10.3608 7.29535 10.2548 7.34386C10.1488 7.39237 10.0346 7.41822 9.91886 7.41987C9.80313 7.42152 9.68825 7.39894 9.58101 7.35348C9.47379 7.308 9.37638 7.24056 9.29455 7.15513C9.21273 7.06971 9.14815 6.96803 9.10463 6.85612C9.06111 6.74419 9.03953 6.6243 9.04116 6.50353C9.0428 6.38276 9.06762 6.26356 9.11415 6.15297C9.1607 6.04238 9.228 5.94265 9.31211 5.85967L13.1546 1.84931C15.518 -0.615834 19.364 -0.617038 21.7274 1.84931C24.0909 4.31565 24.0909 8.32903 21.7274 10.7948L17.8843 14.8057C17.8041 14.8897 17.7087 14.9563 17.6037 15.0016C17.4987 15.0471 17.3855 15.0704 17.2719 15.0703ZM6.55957 24C5.76349 24.0015 4.97497 23.8389 4.23929 23.5215C3.5036 23.2041 2.83524 22.7382 2.27258 22.1505C-0.0908616 19.6836 -0.0908616 15.6708 2.27258 13.2045L5.70748 9.62064C5.78789 9.5367 5.88334 9.47011 5.9884 9.42467C6.09346 9.37922 6.20606 9.35582 6.31979 9.35579C6.43352 9.35577 6.54614 9.37911 6.65121 9.4245C6.7563 9.46989 6.85179 9.53644 6.93222 9.62034C7.01265 9.70423 7.07647 9.80384 7.12001 9.91348C7.16356 10.0231 7.18599 10.1406 7.18601 10.2593C7.18604 10.378 7.16367 10.4955 7.12017 10.6052C7.07667 10.7148 7.0129 10.8145 6.93251 10.8984L3.4976 14.4822C1.80902 16.2437 1.80902 19.1107 3.4976 20.8728C5.18619 22.6343 7.93354 22.6331 9.62097 20.8728L13.0558 17.2878C13.1354 17.2 13.231 17.1299 13.337 17.0813C13.443 17.0328 13.5573 17.0069 13.673 17.0053C13.7888 17.0037 13.9036 17.0262 14.0108 17.0717C14.118 17.1171 14.2155 17.1846 14.2973 17.2701C14.3791 17.3554 14.4437 17.4571 14.4872 17.5691C14.5308 17.681 14.5524 17.8009 14.5507 17.9216C14.5491 18.0424 14.5242 18.1617 14.4777 18.2722C14.4312 18.3828 14.3639 18.4825 14.2797 18.5655L10.846 22.15C10.2835 22.7377 9.6152 23.2036 8.87961 23.521C8.14401 23.8384 7.35557 24.0015 6.55957 24ZM9.95984 15.0328C9.78876 15.0324 9.62165 14.9791 9.47953 14.8797C9.33741 14.7803 9.22664 14.6393 9.16116 14.4743C9.09568 14.3094 9.07841 14.128 9.11154 13.9528C9.14467 13.7776 9.22671 13.6166 9.34733 13.49L13.4288 9.23087C13.5087 9.14456 13.6043 9.07572 13.7099 9.02836C13.8155 8.981 13.9292 8.95607 14.0441 8.95502C14.1591 8.95399 14.2732 8.97685 14.3795 9.02229C14.486 9.06772 14.5826 9.13482 14.6639 9.21966C14.7453 9.30451 14.8096 9.4054 14.8532 9.51646C14.8967 9.62751 14.9186 9.7465 14.9176 9.86649C14.9166 9.98647 14.8926 10.105 14.8473 10.2153C14.8019 10.3255 14.736 10.4253 14.6532 10.5086L10.5718 14.7684C10.4915 14.8525 10.3962 14.9192 10.2912 14.9646C10.1861 15.0101 10.0735 15.033 9.95984 15.0328Z',
    },
  ],
});

register('processor', {
  width: 22,
  height: 22,
  paths: [
    {
      d: 'M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z',
    },
  ],
});

register('add', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z',
    },
  ],
});

register('more', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',
    },
  ],
});

register('check', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
    },
  ],
});

register('folder', {
  width: 15,
  height: 15,
  paths: [
    {
      d: 'M0.492188 1.75312C0.492188 0.966118 1.13018 0.328125 1.91719 0.328125H7.03882C7.26004 0.328125 7.46722 0.436525 7.59335 0.618266L9.28481 3.05544L13.3367 3.05546C14.538 3.05546 15.5117 4.02923 15.5117 5.23045L15.5117 11.4983C15.5117 12.6995 14.538 13.6733 13.3367 13.6733L2.66725 13.6733C1.46604 13.6733 0.492268 12.6995 0.492254 11.4983L0.492188 1.75312ZM7.64154 3.05544L6.68565 1.67813H1.91719C1.87577 1.67813 1.84219 1.7117 1.84219 1.75312V3.05544H7.64154ZM1.8422 4.40545L1.84225 11.4983C1.84226 11.9539 2.21162 12.3233 2.66725 12.3233L13.3367 12.3233C13.7924 12.3233 14.1617 11.9539 14.1617 11.4983L14.1617 5.23045C14.1617 4.77482 13.7924 4.40546 13.3367 4.40546L1.8422 4.40545Z',
    },
  ],
});

register('folder-open', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z',
    },
  ],
});

register('create-folder', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z',
    },
  ],
});

register('user', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
    },
  ],
});

register('add-user', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
    },
  ],
});

register('perm-media', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z',
    },
  ],
});

register('drop-down', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M7 10l5 5 5-5z',
    },
  ],
});

register('shield-lock', {
  width: 18,
  height: 18,
  paths: [
    {
      d: 'M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z',
    },
    {
      d: 'M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z',
    },
  ],
});

register('forum', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z',
    },
  ],
});

register('settings', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z',
    },
  ],
});

register('warning', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 0C18.625 0.00626087 23.9937 5.37496 24 12C24 18.6271 18.6271 24 12 24C5.37287 24 0 18.6271 0 12C0 5.37287 5.37287 0 12 0ZM12 16C11.448 16 11 16.448 11 17C11 17.552 11.448 18 12 18C12.552 18 13 17.552 13 17C13 16.448 12.552 16 12 16ZM13 13V7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V13C11 13.5523 11.4477 14 12 14C12.5523 14 13 13.5523 13 13Z',
    },
  ],
});

register('warning-triangle', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v5h2v-5z',
    },
  ],
});

register('info', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z',
    },
  ],
});

register('cc', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z',
    },
  ],
});

register('spellcheck', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z',
    },
  ],
});

register('highlight-off', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z',
    },
  ],
});

register('edit', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z',
    },
    {
      'fill-opacity': '.36',
      d: 'M0 20h24v4H0z',
    },
  ],
});

register('favorite', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',
    },
  ],
});

register('favorite-border', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z',
    },
  ],
});

register('share', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z',
    },
  ],
});

register('download', {
  width: 16,
  height: 16,
  paths: [
    {
      d: 'M8.46699 12.4733C8.20699 12.732 7.78699 12.732 7.52699 12.4733L2.86699 7.8C2.64047 7.53533 2.65571 7.14133 2.90195 6.89467C3.1482 6.64867 3.54249 6.63333 3.80699 6.86L7.33366 10.3933V1.33333C7.33366 0.965133 7.63212 0.666666 8.00033 0.666666C8.36852 0.666666 8.66699 0.965133 8.66699 1.33333V10.3933L12.1937 6.86667C12.4582 6.64 12.8525 6.65533 13.0987 6.90133C13.3449 7.148 13.3602 7.542 13.1337 7.80667L8.46699 12.4733ZM0.666992 14.6667C0.666992 14.2987 0.965472 14 1.33366 14H14.667C15.0352 14 15.3337 14.2987 15.3337 14.6667C15.3337 15.0347 15.0352 15.3333 14.667 15.3333H1.33366C0.965472 15.3333 0.666992 15.0347 0.666992 14.6667Z',
    },
  ],
});

register('metadata', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z',
    },
  ],
});

register('report', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z',
    },
  ],
});

register('statistic', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z',
    },
  ],
});

register('copy', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z',
    },
  ],
});

register('mobile', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z',
    },
  ],
});

register('first-page', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z',
    },
  ],
});

register('last-page', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z',
    },
  ],
});

register('carousel', {
  width: 26,
  height: 20,
  paths: [
    {
      d: 'M2 7h4v10H2V7zm5 12h10V5H7v14zM18 7h4v10h-4V7z',
    },
  ],
});

register('multiply-media', {
  width: 14,
  height: 12,
  paths: [
    {
      d: 'M1.60433 12.4129H11.3951C12.241 12.4129 12.9291 11.7455 12.9291 10.9251V5.3784C12.9291 4.55804 12.241 3.89062 11.3951 3.89062H1.60433C0.758473 3.89062 0.0703125 4.55804 0.0703125 5.3784V10.9251C0.0703125 11.7455 0.758473 12.4129 1.60433 12.4129ZM5.18537 6.93791C5.18537 6.83124 5.24424 6.73275 5.33966 6.67972C5.43508 6.6267 5.55246 6.62726 5.64735 6.68124L7.83538 7.92558C7.92929 7.97899 7.98697 8.07668 7.98697 8.18225C7.98697 8.28783 7.92926 8.38551 7.83538 8.43892L5.64735 9.68327C5.59943 9.71052 5.5458 9.72415 5.49214 9.72415C5.43952 9.72415 5.38688 9.71103 5.33963 9.68478C5.24421 9.63176 5.18534 9.53327 5.18534 9.4266V6.93791H5.18537Z',
      fill: 'white',
    },
    {
      d: 'M5.4 10.1169V5.8831C5.4 5.80537 5.4848 5.75735 5.55145 5.79735L9.07962 7.91425C9.14436 7.95309 9.14436 8.04691 9.07962 8.08575L5.55145 10.2027C5.4848 10.2426 5.4 10.1946 5.4 10.1169Z',
      fill: 'white',
      stroke: '#3C4148',
      'stroke-width': '0.8',
    },
    {
      d: 'M1.93962 2.9623H11.0563C11.2257 2.9623 11.3631 2.82908 11.3631 2.66474C11.3631 2.5004 11.2257 2.36719 11.0563 2.36719H1.93962C1.7702 2.36719 1.63281 2.5004 1.63281 2.66474C1.63281 2.82908 1.77017 2.9623 1.93962 2.9623Z',
      fill: 'white',
    },
    {
      d: 'M3.35758 1.28261H9.64497C9.81438 1.28261 9.95177 1.14939 9.95177 0.985054C9.95177 0.820715 9.81438 0.6875 9.64497 0.6875H3.35758C3.18817 0.6875 3.05078 0.820715 3.05078 0.985054C3.05078 1.14939 3.18817 1.28261 3.35758 1.28261Z',
      fill: 'white',
    },
  ],
});

register('data-object', {
  width: 28,
  height: 22,
  paths: [
    {
      d: 'M4 7v2c0 .55-.45 1-1 1H2v4h1c.55 0 1 .45 1 1v2c0 1.65 1.35 3 3 3h3v-2H7c-.55 0-1-.45-1-1v-2c0-1.3-.84-2.42-2-2.83v-.34C5.16 11.42 6 10.3 6 9V7c0-.55.45-1 1-1h3V4H7C5.35 4 4 5.35 4 7zm17 3c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3h-3v2h3c.55 0 1 .45 1 1v2c0 1.3.84 2.42 2 2.83v.34c-1.16.41-2 1.52-2 2.83v2c0 .55-.45 1-1 1h-3v2h3c1.65 0 3-1.35 3-3v-2c0-.55.45-1 1-1h1v-4h-1z',
    },
  ],
});

register('antenna', {
  width: 28,
  height: 22,
  paths: [
    {
      d: 'M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z',
    },
  ],
});

register('home', {
  width: 28,
  height: 22,
  paths: [
    {
      d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z',
    },
  ],
});

register('dns', {
  width: 28,
  height: 22,
  paths: [
    {
      d: 'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z',
    },
  ],
});

register('cached', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z',
    },
  ],
});

register('api', {
  width: 24,
  height: 24,
  paths: [
    {
      d: 'M7 7H5a2 2 0 0 0-2 2v8h2v-4h2v4h2V9a2 2 0 0 0-2-2m0 4H5V9h2m7-2h-4v10h2v-4h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2m0 4h-2V9h2m6 0v6h1v2h-4v-2h1V9h-1V7h4v2Z',
    },
  ],
});

export function register(type: string, icon: IconData) {
  if (has(icon, type)) {
    throw new Error('dublicate icon');
  }
  icons[type] = icon;
}
